var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox-checked",
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M19.167,4.5H5.833A1.333,1.333,0,0,0,4.5,5.833V19.167A1.333,1.333,0,0,0,5.833,20.5H19.167A1.333,1.333,0,0,0,20.5,19.167V5.833A1.333,1.333,0,0,0,19.167,4.5ZM5.833,19.167V5.833H19.167V19.167Z",
    transform: "translate(0 0)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M13.339,18.375l-3.214-2.834,1.022-.88,2.192,1.914,4.763-4.2,1.022.9-5.786,5.1Z",
    transform: "translate(-1.625 -2.875)",
    fill: "#74613c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.f41b2d5f39ccedcf60a0a8518cf9f80d.svg";
export { ForwardRef as ReactComponent };